import { render, staticRenderFns } from "./i4pro-radio-group.vue?vue&type=template&id=3fed0fe0"
import script from "./i4pro-radio-group.vue?vue&type=script&lang=js"
export * from "./i4pro-radio-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports